module.exports = __webpack_public_path__ + "static/media/my_counselor.f6b7a37e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my_counselor.svg
// module id = 564
// module chunks = 1